import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "¿Qué es un seguro IUL?", a: "Es un seguro de vida permanente (Indexed Universal Life) que combina un beneficio por fallecimiento para tu familia con una cuenta de valor en efectivo que crece según el desempeño de un índice como el S&P 500, con un piso garantizado del 0%." },
  { q: "¿Puedo perder dinero si el mercado baja?", a: "No por el mercado. El IUL tiene un piso del 0%: cuando el índice cae, tu valor acumulado no disminuye por esa caída. Cuando sube, participas de la ganancia hasta un tope." },
  { q: "¿La cotización tiene algún costo o compromiso?", a: "Ninguno. La cotización y la asesoría son 100% gratuitas y sin compromiso. Tú decides si es la opción adecuada para tu familia." },
  { q: "¿Cómo reclamo el bono de $50 en seguro de auto?", a: "Al enviar el formulario recibes tu código BONO50AUTO. Menciónalo cuando cotices tu seguro de auto con nosotros y aplicamos $50 de descuento en tus cotizaciones." },
  { q: "¿Necesito tener papeles o número de seguro social?", a: "Existen opciones para diferentes situaciones. Lo mejor es hablar con un asesor: te explicamos las alternativas disponibles para tu caso sin costo." },
];

export const FAQ = () => (
  <section id="preguntas" className="py-20 lg:py-28 bg-[var(--slate-50)] scroll-mt-20" data-testid="faq-section">
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
      <p className="text-xs font-bold tracking-[0.2em] text-brand-blue uppercase">Preguntas frecuentes</p>
      <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-navy">
        Resolvemos tus dudas antes de la llamada.
      </h2>
      <Accordion type="single" collapsible className="mt-10 space-y-3">
        {faqs.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`faq-${i}`}
            className="rounded-2xl border border-slate-200 bg-white px-6 data-[state=open]:border-brand-blue/40 data-[state=open]:shadow-md transition-shadow"
            data-testid={`faq-item-${i + 1}`}
          >
            <AccordionTrigger className="text-left font-bold text-navy hover:no-underline py-5" data-testid={`faq-trigger-${i + 1}`}>
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600 leading-relaxed pb-5">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
